/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable no-unused-vars */
import { useCallback, useEffect, useRef } from 'react'

type ReportsRowProps = {
  index: number
  setSize: (index: number, height: number) => void
  children: React.ReactNode
  windowWidth: number
}

const ReportsRow = ({
  index,
  setSize,
  children,
  windowWidth
}: ReportsRowProps) => {
  const rowRef = useRef(null)

  useEffect(() => {
    setSize(index, rowRef.current.getBoundingClientRect().height)
  }, [setSize, index, windowWidth])

  return <div ref={rowRef}>{children}</div>
}

function buildSetSize(
  sizeMap: React.MutableRefObject<{}>,
  ref: React.MutableRefObject<any>
) {
  const setSize = useCallback((index, size) => {
    sizeMap.current = {
      ...sizeMap.current,
      [index]: size
    }

    ref.current.resetAfterIndex(index)
  }, [])

  return setSize
}

const getItemSize = (sizeMap: React.MutableRefObject<{}>, index: number) =>
  sizeMap.current[index] || 30

export { ReportsRow, buildSetSize, getItemSize }
